import React, { useEffect } from "react";
import { usePathname } from "next/navigation";
import Image from "next/image";
import Link from "next/link";
import { useAppDispatch } from "lib/redux/hooks";
import { setIsAuthenticationOpen } from "lib/redux/uiSlice";

interface AuthenticationProps {
  onClose: () => void;
}

export const SaveResumePopup: React.FC<AuthenticationProps> = ({ onClose }) => {
  const dispatch = useAppDispatch();
  // Close the modal when clicking outside the popup
  const handleClickOutside = (event: MouseEvent) => {
    const modal = document.getElementById("auth-modal");
    if (modal && !modal.contains(event.target as Node)) {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClosePopup = () => {
    onClose();
    dispatch(setIsAuthenticationOpen(true));
  };

  return (
    <section className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div
        id="auth-modal"
        className="relative w-[292px] overflow-hidden rounded-3xl bg-white shadow-lg md:w-80 lg:w-96"
      >
        <div className="flex w-full flex-col px-1 py-6">
          <div className="flex items-center justify-between md:justify-center md:gap-2">
            <Image
              src="/assets/reviewPopup/leftWave.png"
              alt="left-wave"
              width={31}
              height={6}
            />
            <h2 className="text-center font-solitreo text-2xl text-[#013B85] md:text-3xl">
              Your Rating Matters
            </h2>
            <Image
              src="/assets/reviewPopup/rightWave.png"
              alt="left-wave"
              width={31}
              height={6}
            />
          </div>
          <p className="mb-2 text-center text-[10px] leading-[11px] text-[#013B85] text-opacity-60 md:text-[12px] md:leading-4 lg:text-sm">
            Please take a moment to rate us. <br />
            Promise!, it won &apos;t take more than 2 seconds.
          </p>
          <div className="mx-auto mb-2">
            <Image
              src="/assets/reviewPopup/reviewImg.png"
              alt="review-illustration"
              width={97}
              height={97}
            />
          </div>
          <Link
            href="https://g.page/r/Cd4Sb8MRbPHEEBE/review"
            target="_blank"
            className="mx-auto w-fit"
          >
            <button className="w-fit rounded-3xl bg-[#072FFF] px-3 py-2 font-montserrat text-xs font-semibold text-white md:text-sm">
              Rate us on Google
            </button>
          </Link>
        </div>
        <div className="w-full">
          <Image
            src="/assets/reviewPopup/waves.png"
            alt="waves-illustration"
            width={497}
            height={105}
          />
        </div>
      </div>
      {/* <div
        id="auth-modal"
        className="relative w-[270px] rounded-3xl bg-white p-6 shadow-lg md:w-80 lg:w-96"
      >
        <button className="absolute right-3 top-2 text-xl" onClick={onClose}>
          &times;
        </button>

        <div className="text-center">
          <h2 className="text-lg font-semibold text-gray-900 md:text-xl lg:text-2xl">
            Resume Downloaded!
          </h2>
          <p className="mt-4 text-sm text-gray-600 md:text-base">
            Your resume has been successfully downloaded.
          </p>
          <p className="mt-2 text-sm text-gray-600 md:text-base">
            Sign up now to save your resume forever, access it anytime, and
            share it effortlessly with potential employers.
          </p>
          <div className="mt-6 flex justify-center">
            <button
              className="rounded-full bg-blue-500 px-4 py-2 text-white shadow hover:bg-blue-700"
              onClick={handleClosePopup}
            >
              Sign Up Now
            </button>
          </div>
        </div>
      </div> */}
    </section>
  );
};
